// extracted by mini-css-extract-plugin
module.exports = {"container":"PdfDocument_container__246UW"};